import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { accent } from '@/components/feature/solution/theme';

interface CapabilityItem {
  icon: string;
  title: string;
  desc: string;
}

interface AgriCapabilitiesProps {
  data: {
    eyebrow: string;
    title: string;
    subtitle: string;
    items: CapabilityItem[];
  };
}

export default function AgriCapabilities({ data }: AgriCapabilitiesProps) {
  const a = accent('green');

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <SectionHeading eyebrow={data.eyebrow} title={data.title} subtitle={data.subtitle} />

        <Reveal className="mt-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {data.items.map((item, idx) => (
              <div
                key={item.title}
                className="p-6 md:p-7 rounded-2xl bg-background-50 border border-background-200 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_12px_32px_rgba(0,0,0,0.08)]"
              >
                <div className="flex items-center justify-between">
                  <span className={`w-12 h-12 flex items-center justify-center rounded-xl ${a.iconBox}`}>
                    <i className={`${item.icon} text-2xl`}></i>
                  </span>
                  <span className="font-heading font-bold text-foreground-200 text-2xl">
                    {String(idx + 1).padStart(2, '0')}
                  </span>
                </div>
                <h3 className="mt-4 font-heading font-bold text-foreground-950 text-lg leading-snug">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}